import type { ReactElement } from 'react'
import { AssetPreviewHost, type PluginId } from '@common/plugin-host'
import { UiProvider } from '@common/ui'
import '@common/ui/styles.css'
import { assetPluginRegistry } from './registry'
import { fetchResourceBytes } from './resources'

export const AssetPluginPreview = ({
  pluginId,
  url,
  mimeType,
}: {
  pluginId: PluginId
  url: string
  mimeType?: string
}): ReactElement => (
  <UiProvider>
    <AssetPreviewHost
      pluginId={pluginId}
      url={url}
      mimeType={mimeType}
      registry={assetPluginRegistry}
      fetchResource={fetchResourceBytes}
    />
  </UiProvider>
)

export default AssetPluginPreview
